import { defineAsyncComponent } from 'vue'
import UserNotificationDataList from './UserNotificationDataList.vue'
import UserNotificationDataListItem from './UserNotificationDataListItem.vue'
import UserNotificationListItemInPopover from './UserNotificationListItemInPopover.vue'

export const coreUserNotificationsRouterPath = '/notifications'

/**
 * ユーザ通知を利用
 */
export const useUserNotificationsFeature = async () => {
  $core.$userNotificationsService.enable()
  $core.$router.addRoute({
    path: coreUserNotificationsRouterPath,
    component: defineAsyncComponent(
      () =>
        //@ts-ignore
        import('./UserNotificationListPage.vue'),
    ),
  })
  $core.VueClass.component('UserNotificationDataListItem', UserNotificationDataListItem)
  $core.VueClass.component(
    'UserNotificationListItemInPopover',
    UserNotificationListItemInPopover,
  )
  $core.VueClass.component('UserNotificationDataList', UserNotificationDataList)
}
